import { useNow } from '../../utils/use-now';

export function TimeAgo({
  value,
  whileMinutes = 15,
  agoHours = 12,
}: {
  value: number;
  whileMinutes?: number;
  agoHours?: number;
}) {
  const now = useNow();
  const seconds = Math.floor((now - value) / 1000);
  let output = `${Math.floor(seconds / 60)} min. ago`;

  if (seconds < 10) {
    output = 'Just now';
  } else if (seconds < 60) {
    output = '< 1 min. ago';
  } else if (seconds > 60 * 60 * agoHours) {
    output = '12+ hours ago';
  }

  return <>{output}</>;
}
